import { Typography } from '@material-ui/core'
import { highSchool } from './types'

const HighSchoolInfo = ({ highSchool, header }: { highSchool: highSchool; header?: boolean }) => {
  if (header) {
    return (
      <div>
        <Typography variant="h6">{highSchool.name}</Typography>
      </div>
    )
  }
  return null
}
export default HighSchoolInfo
